import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import SocialLinks from './SocialLinks.vue'
import { useModalStore } from '~/store/modals.js'

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutMenu',
  setup(__props) {

const modalStore = useModalStore()

const wrapper = ref<HTMLElement>()
const showMenu = ref(false)

onMounted(() => {
  if (!wrapper.value) { return }

  wrapper.value.focus()
})

watch(() => showMenu.value, (val) => {
  if (val) { modalStore.addModal() } else { modalStore.removeModal() }
})


return { __sfc: true,modalStore, wrapper, showMenu, SocialLinks }
}

})